import OutsourcedUserFteService from '../../Services/OutsourcedUserFte/OutsourcedUserFteService';
import EditReverseIobWindowDescription, { ReverseIobItem } from './EditReverseIobWindowDescription';

/**
 * Reverses only the bonus shares billed on the selected FTE entries; their salary IOB is left alone. Same
 * fields as the reverse IOB window, a different endpoint.
 */
class EditReverseBonusIobWindowDescription {
  static titleForCreate = 'Create Reverse Bonus IOB';
  static titleForEdit = 'Create Reverse Bonus IOB';
  static itemType = ReverseIobItem;

  static serviceFunction = (edited) =>
    OutsourcedUserFteService.CreateReverseBonusIob({
      FteEntryIds: edited.FteEntryIds,
      Comments: edited.Comments || null,
      InternalReferenceNumber: edited.InternalReferenceNumber || null,
    });

  static pagesInGeneralEditWizzard = EditReverseIobWindowDescription.pagesInGeneralEditWizzard;
}

export default EditReverseBonusIobWindowDescription;
